import { useQuery } from "@tanstack/react-query";

import { organizationNotifyListQueryOptionsFactory } from "~/providers/factories/organizationNotifyListQueryOptionsFactory";

export const useOrganizationNotifyList = (organizationId: string) => {
  return useQuery(
    organizationNotifyListQueryOptionsFactory.list(organizationId),
  );
};
